<template>
  <div class="col-span-1 p-4 bg-white rounded-2xl shadow font-serif">
    <div class="text-center">
      <div class="flex justify-between items-center mb-4">
        <button @click="prevMonth" class="px-2 py-1 bg-gray-200 rounded hover:bg-blue-800 hover:text-white">←</button>
        <h2 class="text-lg font-bold">{{ monthYear }}</h2>
        <button @click="nextMonth" class="px-2 py-1 bg-gray-200 rounded hover:bg-blue-800 hover:text-white">→</button>
      </div>

      <div class="grid grid-cols-7 gap-2 text-sm font-semibold text-white">
        <div v-for="day in days" :key="day">{{ day }}</div>
      </div>

      <div class="grid grid-cols-7 gap-2 mt-2 text-sm text-gray-800">
        <div v-for="blank in firstDayOfMonth" :key="'b'+blank"></div>
        <div
          v-for="day in daysInMonth"
          :key="day"
          :class="[
            'p-2 text-center rounded cursor-pointer',
            isToday(day) ? 'bg-blue-800 text-white font-bold' : 'hover:bg-blue-100'
          ]"
        >
          {{ day }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentDate: new Date(),
      days: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    };
  },
  computed: {
    monthYear() {
      return this.currentDate.toLocaleString('fr-FR', {
        month: 'long',
        year: 'numeric',
      });
    },
    firstDayOfMonth() {
      const first = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1);
      return first.getDay(); 
    },
    daysInMonth() {
      const year = this.currentDate.getFullYear();
      const month = this.currentDate.getMonth() + 1;
      return new Date(year, month, 0).getDate(); 
    },
  },
  methods: {
    isToday(day) {
      const today = new Date();
      return (
        day === today.getDate() &&
        this.currentDate.getMonth() === today.getMonth() &&
        this.currentDate.getFullYear() === today.getFullYear()
      );
    },
    nextMonth() {
      this.currentDate.setMonth(this.currentDate.getMonth() + 1);
      this.currentDate = new Date(this.currentDate); 
    },
    prevMonth() {
      this.currentDate.setMonth(this.currentDate.getMonth() - 1);
      this.currentDate = new Date(this.currentDate); 
    },
  },
};
</script>
